import { render } from "./StaffCpdProgressTab.vue?vue&type=template&id=b98b975c"
import script from "./StaffCpdProgressTab.vue?vue&type=script&lang=js"
export * from "./StaffCpdProgressTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__